<nav class="navbar navbar-expand-lg fixed-top" style="background-color: #a1d3f7;">
    <div class="container-fluid">
      <a class="navbar-brand" href="https://www.optimusdrive.ai/" style="padding-left: 4rem;">
        <img src="/assets/images/Optimus_Logo.png" alt="Bootstrap" width="200" height="59">
      </a>
  
      <button class="navbar-toggler" type="button" (click)="toggleMobileMenu()"
              [class.collapsed]="isMobileMenuOpen" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
  
      <div class="collapse navbar-collapse" [class.show]="isMobileMenuOpen" id="navbarNavAltMarkup">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="https://www.optimusdrive.ai/" target="_blank">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="https://www.crunchmediaworks.com/team.html" target="_blank">Team</a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="https://www.crunchmediaworks.com/careers.html" target="_blank">Jobs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="https://www.crunchmediaworks.com/press_mentions.html" target="_blank">Press</a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" routerLink="/apilist" target="_blank">
              <button type="button" class="btn btn-primary">Try Our API's</button>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  